import React from 'react'
import styled from 'styled-components'
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded'
import { font, ink, line, radius, surface, transition } from 'features/dashboard/tokens'

const FocusBreadcrumb = ({ trail = [], onCrumb }) => {
  if (trail.length <= 1) return null

  return (
    <Bar aria-label='Focus breadcrumb'>
      {trail.map((crumb, index) => {
        const isLast = index === trail.length - 1
        return (
          <Segment key={`${crumb.key}-${crumb.id ?? index}`}>
            <Crumb
              type='button'
              $current={isLast}
              aria-current={isLast ? 'page' : undefined}
              onClick={() => onCrumb && onCrumb(index)}
            >
              {crumb.label}
            </Crumb>
            {!isLast && <Sep aria-hidden='true'><ChevronRightRoundedIcon style={{ fontSize: 16 }} /></Sep>}
          </Segment>
        )
      })}
    </Bar>
  )
}

export default FocusBreadcrumb

const Bar = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;
  padding: 8px 12px;
  border: 1px solid ${line.base};
  border-radius: ${radius.pill};
  background: ${surface.wash};
`

const Segment = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
`

const Crumb = styled.button`
  border: none;
  background: transparent;
  padding: 2px 6px;
  border-radius: ${radius.sm};
  font-size: ${font.body};
  font-weight: ${({ $current }) => ($current ? 700 : 600)};
  color: ${({ $current }) => ($current ? ink.base : ink.mute)};
  cursor: ${({ $current }) => ($current ? 'default' : 'pointer')};
  transition: ${transition};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 220px;

  &:hover {
    color: ${({ $current }) => ($current ? ink.base : ink.base)};
    background: ${({ $current }) => ($current ? 'transparent' : surface.canvas)};
  }
`

const Sep = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${ink.mute};
  opacity: 0.7;
`
